import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import Header from "../../components/Header";
import { BodegaRacks } from "../../components/BodegaRacks";
import { pageColors } from "../../mock";
import { ArrowLeft } from "lucide-react";

const rand = (a, b) => a + Math.random() * (b - a);

const MARKS = [
  { key: "sup", img: "/img/sup_mark.webp", w: 300, h: 140, to: "/brands/supreme", label: "Supreme" },
  { key: "jordan", img: "/img/jordan_mark.png", w: 190, h: 150, to: "/brands/jordan", label: "Jordan" },
];

const MJsBodega = () => {
  const navigate = useNavigate();
  const stageRef = useRef(null);
  const nodeRefs = useRef({});
  const physRef = useRef(null);
  const rafRef = useRef(null);
  const [, setTick] = useState(0);

  useEffect(() => { document.title = "TMM|MJ'S BODEGA"; }, []);

  useEffect(() => {
    const el = stageRef.current;
    if (!el) return;
    const rect = el.getBoundingClientRect();
    physRef.current = MARKS.map((m) => ({
      ...m,
      x: rand(60, Math.max(80, rect.width - m.w - 60)),
      y: rand(430, Math.max(480, rect.height - 220)),
      vx: rand(0.18, 0.3) * (Math.random() < 0.5 ? -1 : 1),
      vy: rand(0.14, 0.24) * (Math.random() < 0.5 ? -1 : 1),
      angle: rand(-6, 6),
      va: rand(-0.04, 0.04) || 0.02,
      turn: rand(0.003, 0.007),
      wf: rand(0.0004, 0.0009),
      wp: rand(0, Math.PI * 2),
    }));
    setTick((t) => t + 1);
  }, []);

  useEffect(() => {
    const step = (now) => {
      const el = stageRef.current;
      const items = physRef.current;
      if (!el || !items) {
        rafRef.current = requestAnimationFrame(step);
        return;
      }
      const rect = el.getBoundingClientRect();
      for (const it of items) {
        const turn = Math.sin(now * it.wf + it.wp) * it.turn;
        const cos = Math.cos(turn);
        const sin = Math.sin(turn);
        const nvx = it.vx * cos - it.vy * sin;
        it.vy = it.vx * sin + it.vy * cos;
        it.vx = nvx;
        it.x += it.vx;
        it.y += it.vy;
        it.angle += it.va;
        if (it.x < 0) { it.x = 0; it.vx = Math.abs(it.vx); }
        if (it.x + it.w > rect.width) { it.x = rect.width - it.w; it.vx = -Math.abs(it.vx); }
        if (it.y < 140) { it.y = 140; it.vy = Math.abs(it.vy); }
        if (it.y + it.h > rect.height) { it.y = rect.height - it.h; it.vy = -Math.abs(it.vy); }
        it.va *= 0.996;
        const node = nodeRefs.current[it.key];
        if (node) {
          node.style.transform = `translate3d(${it.x}px, ${it.y}px, 0) rotate(${it.angle}deg)`;
        }
      }
      rafRef.current = requestAnimationFrame(step);
    };
    rafRef.current = requestAnimationFrame(step);
    return () => cancelAnimationFrame(rafRef.current);
  }, []);

  const items = physRef.current;

  return (
    <>
      <Header hoverColor={pageColors.fashion} compact={false} />
      <div className="fashion-page-open" ref={stageRef} data-testid="bodega-stage">
        <button className="feed-back" onClick={() => navigate("/fashion")} data-testid="bodega-back">
          <ArrowLeft size={16} /> Back to Fashion
        </button>

        <div className="page-mark-hero" data-testid="bodega-hero">
          <img src="/img/mjss.webp" alt="MJ's Bodega" className="bodega-hero-img" />
        </div>

        <div className="fashion-intro-open">
          <p className="fashion-eyebrow">Curated finds. Tap a mark to shop.</p>
        </div>

        {items && items.map((it) => (
          <button
            key={it.key}
            type="button"
            className="float-link"
            ref={(n) => { nodeRefs.current[it.key] = n; }}
            style={{
              transform: `translate3d(${it.x}px, ${it.y}px, 0) rotate(${it.angle}deg)`,
              width: it.w,
            }}
            onClick={() => navigate(it.to)}
            data-testid={`float-link-${it.key}`}
            title={it.label}
            aria-label={it.label}
          >
            <img src={it.img} alt={it.label} draggable={false} />
          </button>
        ))}
      </div>
      <BodegaRacks />
    </>
  );
};

export default MJsBodega;
